<script setup>
</script>

<template>
  <div class="loading">
    <video loop autoplay muted playsinline preload>
      <source src='/assets/img/loading.mp4' type='video/mp4'>
    </video>
  </div>
</template>

<style lang="scss" scoped>
.loading {
  @include flex-column();
  align-items: center;
  justify-content: center;
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100svh;
  padding: 10px;
  background-color: $white;
  video {
    width: 150px;
  }
}
</style>
